<form [formGroup]="form" novalidate (ngSubmit)="prepareForSave()">

  <h5 mat-dialog-title [ngStyle]="titleStyle">{{modalTitle}}</h5>

  <!-- CONTENT -->
  <mat-dialog-content [class]="class" >

    @if (content) {
      <label for="inputLabel" [innerHTML]="content"></label>
    }

    <textarea  type="text"
      id="inputLabel"
      class="form-control"
      formControlName="label"
      [ngStyle]="styles"
      [placeholder]="required ? currentLabel : ''"
    [value]="currentLabel"></textarea>


    <!-- FORM MESSAGE -->
    @if (form.invalid && (label.dirty || label.touched) && this.formSubmitAttempt) {
      <p class="text-right">
        @if (label.errors.required) {
          <small class="danger text-muted">* Ce champs est requis</small>
        }
      </p>
    }


  </mat-dialog-content>

  <!-- ACTIONS -->
  <mat-dialog-actions>
    <button mat-button type="button" [mat-dialog-close]="false">{{cancel}}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="label.value.trim().length === 0 && required">{{confirm}}</button>

  </mat-dialog-actions>

</form>
